/**
 * @param preferenceCenter {HTMLElement}
 * @param email {string}
 * @return {void}
 */
module.exports = function setPreferenceCenterEmail(preferenceCenter, email) {
    preferenceCenter.querySelectorAll(`[name="email"]`).forEach(emailInput => {
        if (emailInput instanceof HTMLInputElement) {
            emailInput.value = email;
        }
    });
}